/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 后台
 */
'use strict';
angular.module("backstageLeftModule", []).
controller('backstageLeftCtrl', ['$scope', 'modalDialog', '$timeout', '$element', '$q', 'httpService', '$state', function ($scope, modalDialog, $timeout, $element, $q, httpService, $state) {
	initStatus();
	initData();
	$scope.mName = "";

	function initStatus() {
		var urlArray = $state.current.name.split(".");
		$scope.status = {
			selectedModule: urlArray[1],
			selectedItem: urlArray.length < 3 ? urlArray[1] : urlArray[2],
			expanded: [urlArray[1]],
			isnotice: false,
			// http://wix.github.io/angular-tree-control/#boot   组织树的网址
			treeOptions: {//组织树的配置
				nodeChildren: "children",
				dirSelectable: true,
				allowDeselect: false,
				injectClasses: {
					ul: "a1",
					li: "a2",
					liSelected: "a7",
					iExpanded: "a3",
					iCollapsed: "a4",
					iLeaf: "a5",
					label: "a6",
					labelSelected: "rolegrouplabselected"
				},
				isLeaf: function (node) {
					return node.children == null;
				},
				isSelectable: function (node) {
					return node.groupDN !== '1';
				}
			},
			expandedTest: [],
			heightAuto: false, //判断组织树的高是否添加对应的class
		};

		$scope.data = {
			treeData: [], //组织管理组织树数据
			searchData: [], //组织管理搜索数据
			searchVal: '', //组织管理input的val值
		};
		$scope.listShow = false;
		$scope.showDor = false;
	}
	/**
	 * [initData description]初始化数据
	 * @param  {[]}  [description]
	 * @return {[type]} [description]
	 */
	function initData() {
		getAuthority().then(function () {
			if ($state.current.name === "backstage") {
				$timeout(function () {
				/**
				 * 这里是获取是否配置了二级域名 如果没有配置的话 我们要进引导页 
				 */
					getDomainInfo().then(function(boo) {
						if(!boo) {
							//如果没有设置二级域名 就让他跳转页面
							var li = $("#loginSetting"); //获取登陆设置的按钮
							var lidiv1 = $($("#loginSetting div")[0]);
							var lidiv2 = $($("#loginSetting div")[1]);
							var pli = li.parent();
							pli.append("<div class='yindaoye'><div class='yindaoye-font'><i class='iconfont icon-huitui'></i><div class='yindaoye-f'>请点击进入登录管理设置二级域名</div></div></div>");
							var lidiv1Position = lidiv1.offset(); //获取按钮的位置
							var lidiv1width = lidiv1.width(); //获取按钮的宽度
							//下面动态设置提示文字相对于按钮的位置
							$(".yindaoye-font").css('left', lidiv1Position.left + lidiv1width + 5);
							$(".yindaoye-font").css('top', lidiv1Position.top - 10);
							lidiv1.css('z-index', 101);
							lidiv1.css('borderRadius', '3px');
							lidiv2.css('z-index', 101);
							lidiv1.on('click', function() {
								lidiv2.click();
								$(".yindaoye-font").hide();
								$(".yindaoye").css('z-index', 0);
							})
							lidiv2.on('click', function() {
								$(".yindaoye-font").hide();
								$(".yindaoye").css('z-index', 0);
							})
						} else {
							// 这里有问题，如果没有组织用户管理权限 会报错 修改成模拟点击
							// $scope.selectItem('userdisplay','organization');
							// $scope.expand('organization');
							// 模拟点击开始
							let timer; // 延时器
							let $leve1 = $element.find('.menu_start li').eq(0);
							if ($leve1.length > 0) {
								let $a = $leve1.find('.tableTitle a').eq(0);
								let $b = $leve1.find('.tableTitle').eq(0);
								timer = $timeout(() => {
									$a[0].click();
									timer = $timeout(() => {
										// 检查二级菜单，先用1秒钟，等其加载完成后，再模拟点击事件
										let $a_child = $b.next('ul').find('li a');
										if ($a_child.length > 0) {
											$a_child[0].click();
										}
									});
								});
							}
						}
					});
				});
			}
		});
		getOrganization();
		//监听组织管理搜索框数据变化
		$scope.$watch('data.searchVal', function (newVal, oldVal) {
			if (newVal != '') {
				httpService.http('/mcnadmin/admin/group/findGroupsByKey.do', {
					key: newVal
				}, 'get').then(function (res) {
					$scope.data.searchData = res.data;

				})
			} else {
				$scope.data.searchData = [];
			}

		})
	}
	/**
	 *  获取是否设置了二级域名
	 */
	function getDomainInfo() {
		var deffer = $q.defer();
		httpService.http("/mcnadmin/admin/tenant/getCurrTenantConfig.do", '', "post").then(function(data) {
			if(data.data && data.data.domainPrefix) {
				deffer.resolve(true);
			}
			deffer.resolve(false);
		});
		return deffer.promise;
	}
	/**
	 * [selectItem description] 选择模块
	 * @param  {[type]} name [description]
	 * @return {[type]}      [description]
	 */
	$scope.selectItem = function (name, module) {
		if (name != 'organization') $scope.showDor = false;
		if (name === 'noticemanagement') {
			$scope.status.expanded = [];
			$scope.status.isnotice = true;
		} else {
			$scope.status.isnotice = false;
		}
		var urlName = name === module ? "backstage." + name : "backstage." + module + "." + name;
		if(name === 'setSubdomains'){
			httpService.http("/mcnadmin/admin/tenant/getCurrTenantConfig.do", '', "post").then(function(data) {
				if(data.data && data.data.domainPrefix) {
					$state.go("backstage.loginPageMgr.setSuccess",{domainname:data.data.domainPrefix},{reload:'backstage.loginPageMgr.setSuccess'});
				}else{
					$state.go(urlName, {}, {
						reload: urlName
					});
				}
			});
		}else{
			$state.go(urlName, {}, {
				reload: urlName
			});
		}
		$scope.status.selectedItem = name;
		$scope.status.selectedModule = module;
	};
	/**
	 * [expand description] 展开节点
	 * @param  {[string]} name  [description] 节点名称
	 * @return {[type]} [description]
	 */
	$scope.expand = function (name) {
		if ($scope.mName == name) {
			$scope.mName = "";
		} else {
			$scope.mName = name;
		}
		var isExpanded = $scope.isExpanded(name);
		if (isExpanded.flag) {
			$scope.status.expanded.splice(isExpanded.index, 1);
		} else {
			$scope.status.expanded = [];
			$scope.status.expanded.push(name);
		}
	};
	/**
	 * [isExpanded description] 节点是否已经展开
	 * @param  {[string]} name  [description] 节点名称
	 * @return {[type]} [description]
	 */
	$scope.isExpanded = function (name) {
		return {
			flag: $scope.status.expanded.indexOf(name) >= 0,
			index: $scope.status.expanded.indexOf(name)
		};
	};

	/**
	 * [directional description] 自动定向
	 * @return {[type]} [description]
	 */
	function directional() {

	}

	/**
	 * [getAuthority description] 获取权限
	 * @return {[type]} [description]
	 */
	function getAuthority() {
		var deffer = $q.defer();
		httpService.http("/mcnadmin/admin/auth/getCurrUserAuthInfo.do", "", "post").
		then(function (data) {
			
			$scope.data.authority = data.data;
			$scope.$root.authority = $scope.data.authority;
			deffer.resolve();
		});
		return deffer.promise;
	}
	/************************************************************************************ */
	/**
	 * 初始获取全部组织列表
	 */
	function getOrganization() {
		httpService.http('/mcnadmin/admin/group/findGroups.do', {
			groupId: -1
		}, 'get').then(function (res) {
			$scope.data.treeData = [res.data[0]];
		})
	}
	/**
	 * 组织管理搜索获失焦点
	 */
	$scope.JudgingFocus = function () {
		$scope.listShow = true;
	}
	/**
	 * 
	 * @param {*} item
	 * 跳转组织管理页面 
	 */
	$scope.jumpPage = function (item) {
		$scope.status.expandedTest.push($scope.data.treeData[0]);
		$scope.status.selectedNode=item;
		$scope.status.heightAuto=true;
		goToGroup(item); //跳转指定组织
		positionRouter(item.groupId); //跳转组织页面
		$scope.listShow = false; //关闭搜索dom
	}
	$(document).click(function (e) {
		if ($(e.target).closest('.search').length == 0) {
			$scope.listShow = false;
			$scope.$apply();
		}
	})
	/**
	 * [positionRouter description:定位路由跳转]
	 */
	function positionRouter(node) {
		if (!node) return;
		var router = {
			path: 'backstage.organization',
			params: {
				'id': node
			},
		}
		
		$state.go(router.path, router.params, {
			reload: router.path
		});
	};
	/**
	 * [showSelected description]点击组织树节点
	 * @param  {[obj]} node [description]点击的节点
	 * @return {[type]}        [description]
	 */
	$scope.showSelected = function (node) {
		positionRouter(node.groupId);
	};
	//点击展开按钮时可以显示下一层子集结构
	$scope.showToggle = function (node) {
		if (node.groupId === 1) $scope.status.heightAuto = !$scope.status.heightAuto;
		httpService.http('/mcnadmin/admin/group/findGroups.do', {
			groupId: node.groupId
		}, 'get').then(function (res) {
			if (res.data.length == 0) return;
			else {
				node.children = res.data;
			}
		})
	}

	//定位组织树
	// function locationGroupTree(gropuId) {

	// }
	/**
	 * [goToGroup description] 跳转到指定组织
	 * @return {[type]} [description]
	 */
	function goToGroup(newValue) {
		// locationGroupTree(newValue.groudId);
		//expandTreeAndSelectNode(newValue.GROUPIDS);
		$scope.data.searchVal = newValue.groupName;
		positionRouter(newValue.groupId);

	}
	//
	$scope.showDorganization = function () {
		$scope.showDor = !$scope.showDor;
		if ($scope.showDor) {
			$scope.status.expandedTest=[$scope.data.treeData[0]];
			$scope.status.selectedNode=$scope.data.treeData[0].children[0];
			var router = {
				path: 'backstage.organization',
				params: {
					'id': $scope.data.treeData[0].children[0].groupId
				},
			}
			$state.go(router.path, router.params, {
				reload: router.path
			});
			$scope.status.selectedItem = 'organization';
		}

	}
}]);
